import { useState } from "react";
import { toast } from "sonner";
import { api } from "../../lib/api";

// Starts a Stripe hosted-checkout session for a plan and redirects to it.
export function usePlanCheckout() {
  const [busy, setBusy] = useState(null);
  const purchase = async (planId) => {
    setBusy(planId);
    try {
      const origin = typeof window !== "undefined" ? window.location.origin : "";
      const res = await api.post("/payments/checkout", { plan: planId, origin_url: origin });
      if (res.data?.url) {
        window.location.href = res.data.url;
        return;
      }
      toast.error("Could not start checkout");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Payment failed");
    } finally {
      setBusy(null);
    }
  };
  return { busy, purchase };
}
